export const errorMessageList = (groupName?: string) => ({
  name: "氏名に使用できない文字・記号が含まれているか、未入力です。",
  phonetic: "ふりがなの入力内容にひらがな以外が含まれているか、未入力です。",
  email: "メールアドレスが正しくありません。",
  note: "備考・特記事項に使用できない文字・記号が含まれているか、未入力です。",
  groupSize:
    "人数（一般）に正しい値を入力してください（1〜10の整数、合計10人以内）。",
  specialGroupSize: `人数(${groupName})に正しい値を入力してください（0〜10の整数、合計10人以内）。`,
});

export const validations = {
  name: /^[^!@#$%^&*()_+{}/\[\]:;<>,.?~=-]+$/,
  phonetic: /^[\u3041-\u3096ー]+$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  note: /^[^!@#$%^&*()_+{}/\[\]:;<>,.?~=-]*$/,
  groupSize: /^(0|[1-9]\d*)$/,
  specialGroupSize: /^(0|[1-9]\d*)$/,
};


export const FREE_STRING_REGEXP = /^[^!@#$%^&*()_+{}/\[\]:;<>,.?~=-]*$/
export const REQUIRED_STRING_REGEXP = /^[^!@#$%^&*()_+{}/\[\]:;<>,.?~=-]+$/
export const FREE_NUMBER_REGEXP = /^(0|[1-9]\d*)$/
export const HIRAGANA_REGEXP = /^[\u3041-\u3096ー]+$/
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/